import React from "react";
import { cn } from "@/lib/utils";

/**
 * LiquidToggle (gooey) — NEXXIS palette adaptation.
 * Used for EN/ES language toggle AND dark/light mode toggle.
 */
export function LiquidToggle({
  checked = false,
  onCheckedChange,
  className,
  variant = "default", // 'default' | 'inverse'
  size = 32,
}) {
  const handleChange = (e) => {
    onCheckedChange && onCheckedChange(e.target.checked);
  };

  const w = size === 32 ? 52 : Math.round(size * 1.625);

  // colors per variant
  const bgOn = variant === "inverse" ? "#BEE5E0" : "#0D5F5E";
  const bgOff = variant === "inverse" ? "rgba(247,246,242,0.28)" : "rgba(13,95,94,0.22)";
  const circleColor = variant === "inverse" ? "#0D5F5E" : "#F7F6F2";

  return (
    <label
      className={cn("relative block cursor-pointer", className)}
      style={{
        height: size,
        width: w,
        transform: "translateZ(0)",
        backfaceVisibility: "hidden",
      }}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        className="h-full w-full cursor-pointer appearance-none rounded-full outline-none"
        style={{
          background: checked ? bgOn : bgOff,
          transition: "background-color 380ms cubic-bezier(0.22,1,0.36,1)",
        }}
      />
      <svg
        viewBox={`0 0 ${w} ${size}`}
        filter="url(#nxGooFilter)"
        className="pointer-events-none absolute inset-0"
        style={{ fill: circleColor }}
      >
        <circle
          cx="16"
          cy={size / 2}
          r={size / 2 - 6}
          style={{
            transformOrigin: `16px ${size / 2}px`,
            transform: `translateX(${checked ? "12px" : "0px"}) scale(${checked ? "0" : "1"})`,
            transition: "transform 520ms cubic-bezier(0.22,1,0.36,1)",
          }}
        />
        <circle
          cx={w - 16}
          cy={size / 2}
          r={size / 2 - 6}
          style={{
            transformOrigin: `${w - 16}px ${size / 2}px`,
            transform: `translateX(${checked ? "0px" : "-12px"}) scale(${checked ? "1" : "0"})`,
            transition: "transform 520ms cubic-bezier(0.22,1,0.36,1)",
          }}
        />
        {checked && (
          <circle
            cx={w - 17}
            cy={-1}
            r={2.5}
          />
        )}
      </svg>
    </label>
  );
}

export function GooeyFilter() {
  return (
    <svg className="fixed h-0 w-0" aria-hidden="true">
      <defs>
        <filter id="nxGooFilter">
          <feGaussianBlur in="SourceGraphic" stdDeviation="2" result="blur" />
          <feColorMatrix
            in="blur"
            mode="matrix"
            values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7"
            result="goo"
          />
          <feComposite in="SourceGraphic" in2="goo" operator="atop" />
        </filter>
      </defs>
    </svg>
  );
}
